module.exports = __webpack_public_path__ + "media/music.f53b5854.mp3";